import { Link } from 'react-router-dom';
import { Button, Icon } from '../components/ui';
import { usePageMeta } from '../lib/seo';
import { tr } from '../lib/i18n';

export function NotFoundPage(): JSX.Element {
  usePageMeta(tr('Página não encontrada'), tr('A página que você procura não existe ou foi movida.'), '/404');

  return (
    <section className="mx-auto flex w-full max-w-content flex-col items-center px-4 py-20 text-center">
      <span className="rounded-full border border-line bg-card p-3 text-muted" aria-hidden="true">
        <Icon name="search" size={26} />
      </span>
      <p className="mt-6 font-mono text-sm uppercase tracking-widest text-muted">{tr("Erro 404")}</p>
      <h1 className="mt-2 text-4xl font-display font-semibold text-ink">{tr("Página não encontrada")}</h1>
      <p className="mt-3 max-w-md text-muted">
        {tr("O endereço que você acessou não existe. Talvez o link esteja antigo ou o perfil do profissional tenha sido removido.")}
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/">
          <Button variant="secondary" icon={<Icon name="back" />}>
            {tr("Voltar ao início")}
          </Button>
        </Link>
        <Link to="/busca">
          <Button>{tr("Buscar profissionais")}</Button>
        </Link>
      </div>
    </section>
  );
}
